import { useEffect, useState, useRef } from "react";
import { Modal, Input, DatePicker, TimePicker, Select, Button, Drawer, Checkbox, Row, Col, Card, message } from "antd";
import moment from "moment";
import db from "../../../../database";
import { SyncData } from "./SyncData";
import { PhoneOutlined, ClockCircleOutlined, TeamOutlined, CheckOutlined, CloseOutlined, SearchOutlined, AppstoreAddOutlined, ExpandAltOutlined } from "@ant-design/icons";
import TableManagement from "./tables";
import { getCustomer } from "../../Core/customer";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

const TableFeatures = (props) => {
  const {
    open,
    onCancel,
    onConfirm,
    drawerOpen,
    closeDrawer,
    reservations,
    mergeDrawerOpen,
    closeMergeDrawer,
    mergeTablesList,
    waitlistDrawerOpen,
    closeWaitlistDrawer,
    waitlistData,
    waitlistTab,
    setWaitlistTab,
    waitlistForm,
    setWaitlistForm,
    validateWaitlistForm,
    waitlistErrors,
    setWaitlistErrors,
    waitlistList,
    setWaitlistList,
    getWaitlist,
    saveToWaitlist,
    reservationList,
    setReservationList,
    form,
    setForm,
    errors,
    setErrors,
    handleCancelReservation,
    selectData,
    setSelectData,
    tableList,
    setTableList,
    reserveModalOpen,
    setReserveModalOpen,
    setDrawerOpen,
    setWaitlistDrawerOpen,
    setTableCards,
    setOcupiedTablesData,
    setReservedTablesData,
    setMainTableData,
    handleTable,
    setReservationsBlank,
    reservationsBlank,
    loadReservations,
    setDisplayReserveTablesPopup,
    handleReserveTable,
    setFieldsValue,
    displayReserveTablesPopup,
    guestForm,
    handleNumberClick,
    reserveTableForm,
    handleClick,
    inputFields,
    setInputFields,
    numbers,
    setNumberOfPersons,
    noOfPersons,
    handleOnChange,
    loadWaitlistForUI,
    setReservePhone,
    reservePhone,
    addNewCustomer,
    cart,
    setCart,
    seatGuestDrawerOpen,
    setSeatGuestDrawerOpen,
    transferBill,
    setTransferBill,
    tableCards,
    selectedTable,
    keyValue,
    setShowProducts,
    clearCartData,
    setLoading,
  } = props;
  const history = useHistory();
  const tableData = tableCards;
  const guestNameRef = useRef(null);
  const waitlistNameRef = useRef(null);
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const [searchText, setSearchText] = useState("");
  const [filterDate, setFilterDate] = useState(null);
  const [activeFeatureTab, setActiveFeatureTab] = useState("reservations");
  const [selectedWaitlistGuest, setSelectedWaitlistGuest] = useState(null);
  const [selectedTableForSeating, setSelectedTableForSeating] = useState(null);
  const [isNewWaitlistCustomer, setIsNewWaitlistCustomer] = useState(false);
  const [mergeOrSplitAction, setMergeOrSplitAction] = useState("merge"); // "merge" or "split"
  const [selectedTablesForMerge, setSelectedTablesForMerge] = useState([]);
  const [checkInDrawerOpen, setCheckInDrawerOpen] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [selectedCheckInTable, setSelectedCheckInTable] = useState(null);
  const [phoneError, setPhoneError] = useState("");

  const handleSeatGuestToTable = async (table, guest) => {
    console.log("table ==========>", table);
    // update table values
    table.statusType = "STD";
    table.guestName = guest.name;
    table.noOfPersons = guest.guests;
    table.mobile = guest.phone;
    table.color = "#93C5FD";
    table.time = moment().format("YYYY-MM-DD HH:mm:ss");
    table.tableSync = "N";
    table.startedAt = moment().format("YYYY-MM-DD HH:mm"); // <--- New field

    await db.tableData.put(table);

    await SyncData(table, "upsertTableStatus");

    saveToWaitlist({
      ...guest,
      waitlistId: guest.id,
      status: "CL",
    });

    const updatedTables = await db.tableData.toArray();
    setTableCards(updatedTables);
    setMainTableData(updatedTables);
    setOcupiedTablesData(updatedTables.filter((t) => t.statusType === "OCU" || table.statusType === "ONG"));
    setReservedTablesData(updatedTables.filter((t) => t.statusType === "RES"));
    setTableList(updatedTables);

    setCart((prev) => {
      const updated = {
        ...prev,
        customer: {
          cwrCustomerId: guest.cwrCustomerId || null,
          name: guest.name,
          mobileNo: guest.phone,
        },
      };
      localStorage.setItem("cartObj", JSON.stringify(updated));
      return updated;
    });

    setSeatGuestDrawerOpen(false);
  };

  const handleTransferBill = async (fromTable, toTable) => {
    if (!fromTable || !toTable) return;
    if (fromTable.cwrFbTableId === toTable.cwrFbTableId) {
      message.warning("Please select a different table for transfer");
      return;
    }

    // 1️⃣ FETCH ORDERS FROM BOTH TABLES
    const [fromOrders, toOrders] = await Promise.all([
      db.fbOrderData.where("cwrFbTableId").equals(fromTable.cwrFbTableId).toArray(),
      db.fbOrderData.where("cwrFbTableId").equals(toTable.cwrFbTableId).toArray(),
    ]);

    const fromOrder = fromOrders.find((o) => o.fbOrderStatus === "IP");
    const toOrder = toOrders.find((o) => o.fbOrderStatus === "IP");

    // If no bill exists in source table, nothing to transfer
    if (!fromOrder) {
      message.warning("No active bill in this table to transfer");
      return;
    }

    // 2️⃣ CASE 1: DEST TABLE HAS **NO ORDER** → MOVE BILL COMPLETELY
    if (!toOrder) {
      let cartObj = JSON.parse(localStorage.getItem("cartObj")) ? JSON.parse(localStorage.getItem("cartObj")) : cart;
      // move fbOrder to destination table
      fromOrder.cwrFbTableId = toTable.cwrFbTableId;
      fromOrder.fbOrderSync = "N";
      fromOrder.cart = {
        ...cartObj,
        tableNo: toTable.table, // if you store table number in cart
      };
      await db.fbOrderData.put(fromOrder, fromOrder.fbOrderId);

      // source table becomes OPEN
      await db.tableData
        .where("cwrFbTableId")
        .equals(fromTable.cwrFbTableId)
        .modify((t) => {
          t.items = [];
          t.totalAmount = 0;
          t.statusType = "OPN";
          t.tableSync = "N";
          t.lines = [];
          if ("wsData" in t) {
            delete t.wsData;
          }
        });

      // destination table becomes OCCUPIED / ONGOING
      await db.tableData
        .where("cwrFbTableId")
        .equals(toTable.cwrFbTableId)
        .modify((t) => {
          t.items = fromOrder.cart.items || [];
          t.totalAmount = fromOrder.cart.total || 0;
          t.noOfPersons = fromTable.noOfPersons ?? t.noOfPersons;
          t.guestName = fromTable.guestName ?? t.guestName;
          t.waiter = fromTable.waiter ?? t.waiter;
          t.statusType = "ONG"; // or "OCU"
          t.tableSync = "N";
          t.time = moment().format("YYYY-MM-DD HH:mm:ss");
        });

      // get updated table rows for sync
      const [updatedFromTable] = await db.tableData.where("cwrFbTableId").equals(fromTable.cwrFbTableId).toArray();
      const [updatedToTable] = await db.tableData.where("cwrFbTableId").equals(toTable.cwrFbTableId).toArray();

      if (updatedFromTable) await SyncData(updatedFromTable, "upsertTableStatus");
      if (updatedToTable) await SyncData(updatedToTable, "upsertTableStatus");
      await SyncData(fromOrder, "upsertFbOrder", setLoading, "", true);
      // update current cart if user is on this order
      setCart(fromOrder.cart);
      localStorage.setItem("cartObj", JSON.stringify(fromOrder.cart));
      localStorage.setItem("tableName", JSON.stringify(updatedToTable));

      message.success(`Bill transferred to ${toTable.name}`);
      setShowProducts(false);
    }

    // 3️⃣ CASE 2: DEST TABLE **ALREADY HAS ORDER** → MERGE BILLS
    else {
      // merge cart items & totals
      const fromItems = fromOrder.cart?.items || [];
      const toItems = toOrder.cart?.items || [];

      const mergedItems = [...toItems, ...fromItems];

      const mergedTotal = (toOrder.cart?.total || 0) + (fromOrder.cart?.total || 0);

      toOrder.cart = {
        ...toOrder.cart,
        items: mergedItems,
        total: mergedTotal,
        tableNo: toTable.table,
      };

      // also merge order lines (important for backend)
      const fromLines = fromOrder.lines || [];
      const toLines = toOrder.lines || [];
      toOrder.lines = [...toLines, ...fromLines];

      toOrder.fbOrderSync = "N";

      // mark source order as merged/closed
      fromOrder.cart = {
        ...fromOrder.cart,
        items: [],
        total: 0,
      };
      fromOrder.fbOrderStatus = "IP"; // or "CL" / "CN" as per backend convention
      fromOrder.fbOrderSync = "N";

      await db.fbOrderData.put(toOrder, toOrder.fbOrderId);
      await db.fbOrderData.put(fromOrder, fromOrder.fbOrderId);

      // CLEAR SOURCE TABLE
      await db.tableData
        .where("cwrFbTableId")
        .equals(fromTable.cwrFbTableId)
        .modify((t) => {
          t.items = [];
          t.totalAmount = 0;
          t.statusType = "OPN";
          t.tableSync = "N";
        });

      // UPDATE DEST TABLE
      await db.tableData
        .where("cwrFbTableId")
        .equals(toTable.cwrFbTableId)
        .modify((t) => {
          t.items = mergedItems;
          t.totalAmount = mergedTotal;
          t.statusType = "ONG"; // or "OCU"
          t.tableSync = "N";
          t.time = moment().format("YYYY-MM-DD HH:mm:ss");
        });

      const [updatedFromTable] = await db.tableData.where("cwrFbTableId").equals(fromTable.cwrFbTableId).toArray();
      const [updatedToTable] = await db.tableData.where("cwrFbTableId").equals(toTable.cwrFbTableId).toArray();

      if (updatedFromTable) await SyncData(updatedFromTable, "upsertTableStatus");
      if (updatedToTable) await SyncData(updatedToTable, "upsertTableStatus");
      await SyncData(toOrder, "upsertFbOrder");
      await SyncData(fromOrder, "upsertFbOrder"); // to update status to MRG

      // update UI cart to show merged bill on destination table
      setCart(toOrder.cart);
      localStorage.setItem("cartObj", JSON.stringify(toOrder.cart));
      localStorage.setItem("tableName", JSON.stringify(updatedToTable));

      message.success(`Bill merged with ${toTable.name}`);
      setShowProducts(false);
    }

    // 4️⃣ REFRESH TABLE UI + CLOSE POPUP
    const updatedTables = await db.tableData.toArray();
    setTableCards(updatedTables);
    setTableList(updatedTables);
    setOcupiedTablesData(updatedTables.filter((t) => t.statusType !== "OPN"));

    setSelectedTableForSeating(null);
    setSeatGuestDrawerOpen(false);
    setTransferBill(false);
  };
  const resetWaitlistForm = () => {
    setWaitlistForm({
      name: "",
      phone: "",
      guests: "",
      eta: "",
    });

    setWaitlistErrors({});
  };

  const handleWaitlistContactSearch = async (e) => {
    let val = e.target.value.replace(/\D/g, "");
    e.target.value = val;

    // Set phone in form
    setWaitlistForm((prev) => ({ ...prev, phone: val }));

    if (val.length > 0 && val.length !== 10) {
      setPhoneError("Contact number must be 10 digits");
      return;
    }

    // ✅ Clear error once valid
    setPhoneError("");

    // Reset if not full number
    if (val.length !== 10) {
      setWaitlistForm((prev) => ({ ...prev, name: "" }));
      setIsNewWaitlistCustomer(false);
      return;
    }

    // 🔥 Call existing customer API
    const response = await getCustomer(
      null, // form not required
      2,
      val,
      null,
      () => {},
      null,
      tillData
    );

    const list = response?.data?.data?.customerSearch || [];

    const match = list.find((x) => x.mobileNo?.toString() === val.toString());

    if (match) {
      // Existing customer
      setWaitlistForm((prev) => ({
        ...prev,
        name: match.name,
      }));
      setIsNewWaitlistCustomer(false);
      return;
    }

    // New customer
    setWaitlistForm((prev) => ({ ...prev, name: "" }));
    setIsNewWaitlistCustomer(true);
  };

  // "current" | "add"
  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        guestNameRef.current?.focus();
      }, 200);
    }
  }, [open]);
  useEffect(() => {
    if (waitlistTab === "add") {
      setTimeout(() => {
        waitlistNameRef.current?.focus();
      }, 200);
    }
  }, [waitlistTab]);

  const notifyGuest = (index) => {
    setWaitlistList((prev) => prev.map((g, i) => (i === index ? { ...g, notified: true } : g)));
  };

  const filteredReservations = reservationList.filter((res) => {
    let matchSearch = true;
    let matchDate = true;

    // Search filter (name or phone)
    if (searchText.trim()) {
      matchSearch = res.name.toLowerCase().includes(searchText.toLowerCase()) || res.phone.includes(searchText);
    }

    // Date filter (match date exactly)
    if (filterDate) {
      matchDate = res.date === filterDate.format("DD-MM-YYYY");
    }

    return matchSearch && matchDate;
  });

  const countNewReservations = (reservationList) => {
    if (!reservationList || reservationList.length === 0) return 0;

    return reservationList.filter((res) => res.status === "NEW").length;
  };

  const handleAddToWaitlist = () => {
    if (!validateWaitlistForm()) return;

    const newGuest = {
      id: waitlistList.length + 1,
      name: waitlistForm.name,
      phone: waitlistForm.phone,
      guests: waitlistForm.guests,
      eta: `${waitlistForm.eta} min`,
      notified: false,
    };

    setWaitlistList((prev) => [...prev, newGuest]);

    // clear form
    setWaitlistForm({
      name: "",
      phone: "",
      guests: "",
      eta: "",
    });

    setWaitlistErrors({});
    setWaitlistTab("current"); // switch back to current list
  };

  const handleReservationCheckIn = async (reservation, tab, statusType) => {
    // ⭐ Use the SELECTED table (just like waitlist seating)
    const tableId = tab.cwrFbTableId;
    const sectionId = tab.cwrFbsectionId;

    if (!tableId) {
      return Modal.error({
        title: "Invalid Table",
        content: "Please select a valid table.",
      });
    }

    let table = await db.tableData.where("cwrFbTableId").equals(tableId).first();
    if (!table) {
      return Modal.error({
        title: "Table not found",
        content: `Table ${tableId} does not exist`,
      });
    }

    // ⭐ Update table values (exactly like waitlist seating)
    table.statusType = statusType || "RES";
    table.color = "#93C5FD";
    table.guestName = reservation.name;
    table.noOfPersons = reservation.guests;
    table.mobile = reservation.phone;
    table.time = moment().format("YYYY-MM-DD HH:mm:ss");
    table.tableSync = "N";

    await db.tableData.put(table);

    // ⭐ Update reservation with selected table
    reservation.tableId = tableId;
    reservation.sectionId = sectionId;
    reservation.status = "CL";
    reservation.mobile = reservation.phone;

    await SyncData(table, "upsertTableStatus");
    await SyncData(reservation, "reservation");

    // Refresh UI
    const updatedTables = await db.tableData.toArray();
    const sortedTables = updatedTables.sort((a, b) => a.originalIndex - b.originalIndex);

    setTableCards(sortedTables);
    setMainTableData(sortedTables);
    setOcupiedTablesData(sortedTables.filter((t) => t.statusType === "OCU"));
    setReservedTablesData(sortedTables.filter((t) => t.statusType === "RES"));
    setTableList(sortedTables);
    console.log("updatedTables", updatedTables);

    // Open table
    setCart((prev) => ({
      ...prev,
      customer: {
        cwrCustomerId: reservation.cwrCustomerId || null,
        name: reservation.name,
        mobileNo: reservation.phone,
      },
    }));
    console.log("cart before  ==========>", cart);
    localStorage.setItem(
      "cartObj",
      JSON.stringify({
        ...cart,
        customer: {
          cwrCustomerId: reservation.cwrCustomerId || null,
          name: reservation.name,
          mobileNo: reservation.phone,
        },
      })
    );
    console.log("cart after  ==========>", cart);
    handleTable(table);
    setDrawerOpen(false);
  };

  // Show only TODAY + not closed
  const today = moment().format("YYYY-MM-DD");

  const filteredWaitlist = waitlistList.filter((guest) => {
    const createdDate = moment(guest.created).format("YYYY-MM-DD");
    return guest.status !== "CL" && createdDate === today;
  });

  const handleTableSelection = (tableId) => {
    if (mergeOrSplitAction === "merge") {
      // Multiple selection for merge
      setSelectedTablesForMerge((prev) => {
        if (prev.includes(tableId)) {
          return prev.filter((id) => id !== tableId);
        } else {
          return [...prev, tableId];
        }
      });
    } else {
      // Single selection for split
      setSelectedTablesForMerge((prev) => {
        if (prev.includes(tableId)) {
          return [];
        } else {
          return [tableId];
        }
      });
    }
  };

  const handleActionChange = (action) => {
    setMergeOrSplitAction(action);
    setSelectedTablesForMerge([]); // Clear selections when switching
  };

  const handleSplitTableClick = async () => {
    if (mergeOrSplitAction !== "split" || selectedTablesForMerge.length !== 1) {
      message.warning("Please select exactly one table to split");
      return;
    }

    const tableId = selectedTablesForMerge[0];
    const table = tableList.find((t) => t.cwrFbTableId === tableId);

    if (!table) {
      message.error("Table not found");
      return;
    }

    const capacity = table.capacity || 0;
    if (capacity <= 1) {
      message.error("Cannot split table with capacity 1 or less");
      return;
    }

    // Calculate split capacities
    const splitA = Math.ceil(capacity / 2);
    const splitB = Math.floor(capacity / 2);

    const splitConfigs = [
      {
        splitTable: `${table.name}-1`,
        status: "OPN",
        guests: splitA,
        guestName: "",
        guestType: "",
        salesRepId: table.salesRepId || "",
      },
      {
        splitTable: `${table.name}-2`,
        status: "OPN",
        guests: splitB,
        guestName: "",
        guestType: "",
        salesRepId: table.salesRepId || "",
      },
    ];

    await db.tableData.update(table.cwrFbTableId, {
      // statusType: "SPL",
      isSplitParent: "Y",
      splitTables: splitConfigs,
      displayName: `${table.name} (Split)`,
      color: "#f4a261",
      tabbleSync: "N", // Note: using tabbleSync to match existing typo in schema
    });

    const parentTableData = await db.tableData.get(table.cwrFbTableId);
    console.log("[v0] Split table data to sync:", parentTableData);
    await SyncData(parentTableData, "upsertTableStatus");

    const updatedTables = await db.tableData.toArray();
    console.log(
      "[v0] Tables after split:",
      updatedTables.filter((t) => t.cwrFbTableId === table.cwrFbTableId)
    );

    setTableCards(updatedTables);
    setTableList(updatedTables);

    if (setMainTableData) {
      setMainTableData(updatedTables);
    }

    message.success(`Table split successfully into ${table.name}-1 (${splitA} capacity) and ${table.name}-2 (${splitB} capacity)`);
    closeMergeDrawer();
    setSelectedTablesForMerge([]);
  };

  const handleMergeTables = async () => {
    if (mergeOrSplitAction !== "merge" || selectedTablesForMerge.length < 2) return;

    const masterTableId = selectedTablesForMerge[0];
    const childTableIds = selectedTablesForMerge.slice(1);
    const masterTable = tableList.find((t) => t.cwrFbTableId === masterTableId);
    if (!masterTable) return;

    // 🔹 build merge array in final format (only children)
    const mergeEntries = childTableIds.map((tableId) => ({
      fbMergeId: uuidv4().replace(/-/g, "").toUpperCase(),
      fbMTableId: tableId,
      fbMergeReason: "",
    }));
    console.log("mergeEntries =========>", mergeEntries);
    // this is what SyncData will convert into GraphQL `merge: [...]`
    const item = {
      fbtableStatusId: masterTable.fbtableStatusId || uuidv4().replace(/-/g, "").toUpperCase(),
      cwrFbTableId: masterTable.cwrFbTableId, // parent only
      cwrFbsectionId: masterTable.cwrFbSectionId || masterTable.cwrFbsectionId,
      statusType: "ONG",
      noOfPersons: masterTable.noOfPersons || 0,
      guestName: masterTable.guestName || "",
      guestType: masterTable.guestType || "",
      referredBy: masterTable.referredBy || "",
      waiter: masterTable.waiter || null,
      merge: mergeEntries,
    };
    console.log("item ===========>", item);
    await SyncData(item, "upsertTableStatus");

    // 🔹 store same merge array into db.tableData for UI
    await db.tableData
      .where("cwrFbTableId")
      .anyOf(selectedTablesForMerge)
      .modify((t) => {
        t.tableSync = "N";

        if (t.cwrFbTableId === masterTableId) {
          t.statusType = "ONG";
          t.isMergedParent = "Y";
          t.mergedTableIds = childTableIds;

          const childNames = childTableIds
            .map((id) => {
              const child = tableList.find((tbl) => tbl.cwrFbTableId === id);
              return child?.name;
            })
            .filter(Boolean);

          t.displayName = [t.name, ...childNames].join(" + ");

          t.merge = mergeEntries;
        } else {
          t.isMergedChild = "Y";
          t.parentTableId = masterTableId;
          t.merge = null;
        }
      });

    const updatedTables = await db.tableData.toArray();
    setTableCards(updatedTables);
    setTableList(updatedTables);

    closeMergeDrawer();
    setSelectedTablesForMerge([]);
    setMergeOrSplitAction("merge");
  };

  const isNormalAvailableTable = (tbl) => {
    return (
      tbl.statusType === "OPN" && // Available
      tbl.isactive === "Y" &&
      // ❌ Exclude merged tables
      tbl.isMergedParent !== "Y" &&
      tbl.isMergedChild !== "Y" &&
      // ❌ Exclude split tables
      tbl.isSplitParent !== "Y" &&
      // ❌ Exclude booked / running tables
      tbl.ordered !== "Y"
    );
  };

  return (
    <>
      {keyValue === "4" && (
        <div
          style={{
            width: "100%",
            height: "100%",
            background: "#fff",
            padding: "20px",
            overflowY: "auto",
          }}
        >
          {/* ---------- Title + Search (Right Aligned) ---------- */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 20,
              width: "100%",
            }}
          >
            <h1
              style={{
                fontSize: 28,
                fontWeight: 700,
                margin: 0,
              }}
            >
              Reservations Management
            </h1>
          </div>

          {/* ---------- Tabs ---------- */}
          <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
            {/* Reservations TAB */}
            <div
              onClick={() => {
                setActiveFeatureTab("reservations");
                loadReservations();
              }}
              style={{
                padding: "10px 20px",
                borderRadius: 16,
                background: activeFeatureTab === "reservations" ? "#2F3856" : "#F4F4F5",
                color: activeFeatureTab === "reservations" ? "#fff" : "#000",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Reservations {countNewReservations}
            </div>

            {/* Waitlist TAB */}
            <div
              onClick={async () => {
                setActiveFeatureTab("waitlist");
                const list = await loadWaitlistForUI(); // get data
                setWaitlistList(list); // store it
              }}
              style={{
                padding: "10px 20px",
                borderRadius: 16,
                background: activeFeatureTab === "waitlist" ? "#2F3856" : "#F4F4F5",
                color: activeFeatureTab === "waitlist" ? "#fff" : "#000",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Waitlist {filteredWaitlist.length}
            </div>
          </div>

          {/* ---------- Showing Count + Reserve Table Button ---------- */}
          {activeFeatureTab === "reservations" && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 20,
                marginTop: 5,
              }}
            >
              <p style={{ fontSize: 14, fontWeight: 500, color: "#444", margin: 0 }}>Showing {countNewReservations} reservations</p>

              <Button
                style={{
                  background: "#2F3856",
                  color: "#fff",
                  borderRadius: 10,
                  padding: "0 20px",
                  height: 32,
                  fontWeight: 600,
                }}
                onClick={() => {
                  handleReserveTable();
                }}
              >
                Reserve Table
              </Button>
            </div>
          )}

          {activeFeatureTab === "waitlist" && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 20,
                marginTop: 5,
              }}
            >
              <p style={{ fontSize: 14, fontWeight: 500, color: "#444", margin: 0 }}>Showing {filteredWaitlist.length} waitlist</p>

              <Button
                style={{
                  background: "#2F3856",
                  color: "#fff",
                  borderRadius: 10,
                  padding: "0 20px",
                  height: 32,
                  fontWeight: 600,
                }}
                onClick={() => {
                  setWaitlistTab("add"); // 🔥 Switch to ADD form
                  setWaitlistDrawerOpen(true); // 🔥 Open the Waitlist drawer
                  resetWaitlistForm();
                }}
              >
                New Waitlist
              </Button>
            </div>
          )}

          {/* ---------- Reservation List ---------- */}
          {activeFeatureTab === "reservations" && (
            <div
              style={{
                maxHeight: "60vh",
                overflowY: "auto",
                paddingRight: 10,
              }}
            >
              {(() => {
                // 💥 Compute NEW reservation count BEFORE rendering
                const newCount = filteredReservations.filter((res) => res.status !== "CL").length;

                // CASE 1 → filtered list has items but none are NEW
                if (filteredReservations.length > 0 && newCount === 0) {
                  return <p style={{ textAlign: "center", color: "#888", marginTop: 30 }}>No reservations found</p>;
                }

                // CASE 2 → nothing in filtered list at all
                if (filteredReservations.length === 0) {
                  return <p style={{ textAlign: "center", color: "#888", marginTop: 30 }}>No reservations found</p>;
                }

                // CASE 3 → show only non-CL reservations
                return filteredReservations
                  .filter((res) => res.status !== "CL")
                  .map((res, index) => (
                    <div
                      key={index}
                      style={{
                        border: "1px solid #E5E7EB",
                        padding: "20px",
                        borderRadius: 12,
                        marginBottom: 20,
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <span style={{ fontSize: "15px", fontWeight: 500 }}>{res.name}</span>

                            <span
                              style={{
                                background: res.status === "confirmed" ? "#C7F9CC" : "#FFE8A3",
                                color: "#333",
                                padding: "2px 10px",
                                fontSize: "13px",
                                borderRadius: 8,
                              }}
                            >
                              {res.status === "OCU" ? "Occupied" : res.status === "STD" ? "Seated" : res.status}
                            </span>
                          </div>

                          <div style={{ marginTop: 8, display: "flex", gap: 25 }}>
                            <span>
                              <PhoneOutlined /> {res.phone}
                            </span>
                            <span>
                              <ClockCircleOutlined /> {res.time}
                            </span>
                            <span>
                              <TeamOutlined /> {res.guests} guests
                            </span>
                          </div>
                        </div>

                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <Button
                            icon={<CheckOutlined />}
                            style={{
                              background: "#2F3856",
                              color: "#fff",
                              borderRadius: 10,
                              padding: "0 18px",
                              height: 40,
                              display: res.status === "OCU" || res.status === "STD" ? "none" : "",
                            }}
                            onClick={() => {
                              setSelectedReservation(res);
                              setCheckInDrawerOpen(true);
                            }}
                          >
                            Check In
                          </Button>

                          <Button
                            icon={<CloseOutlined />}
                            style={{
                              borderRadius: 10,
                              padding: "0 18px",
                              height: 40,
                            }}
                            onClick={() => {
                              let reserve = res;
                              reserve.status = "CL";
                              SyncData(reserve, "reservation");
                            }}
                          >
                            No Show
                          </Button>
                        </div>
                      </div>
                    </div>
                  ));
              })()}
            </div>
          )}
          {activeFeatureTab === "waitlist" && (
            <div
              style={{
                maxHeight: "60vh",
                overflowY: "auto",
                paddingRight: 10,
              }}
            >
              {console.log("filteredWaitlist ==========>", filteredWaitlist)}
              {filteredWaitlist.length === 0 ? (
                <p style={{ textAlign: "center", color: "#888", marginTop: 40 }}>No guests in waitlist</p>
              ) : (
                filteredWaitlist.map((guest, index) => (
                  <div
                    key={index}
                    style={{
                      border: "1px solid #E5E7EB",
                      padding: "20px",
                      borderRadius: 12,
                      marginBottom: 20,
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      {/* LEFT SIDE (Name, Status, Phone, Guests) */}
                      <div>
                        {/* NAME + STATUS BADGE */}
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <span style={{ fontSize: "15px", fontWeight: 500 }}>{guest.name}</span>

                          <span
                            style={{
                              padding: "2px 10px",
                              fontSize: "13px",
                              borderRadius: 8,
                              background:
                                guest.status === "STD"
                                  ? "#DBEAFE" // Seated - blue
                                  : guest.status === "CL"
                                    ? "#E5E7EB" // Closed - gray
                                    : guest.notified
                                      ? "#C7F9CC" // Notified - green
                                      : "#FFE8A3", // Waiting - yellow
                              color: guest.status === "STD" ? "#1E3A8A" : guest.status === "CL" ? "#374151" : "#333",
                            }}
                          >
                            {guest.status === "WAT"
                              ? `Waiting • ${guest.eta} min`
                              : guest.status === "STD"
                                ? "Seated"
                                : guest.status === "CL"
                                  ? "Closed"
                                  : guest.notified
                                    ? "Notified"
                                    : guest.eta
                                      ? `Waiting • ${guest.eta} min`
                                      : "Waiting"}
                          </span>
                        </div>

                        {/* Contact + Guest Count */}
                        <div style={{ marginTop: 8, display: "flex", gap: 25 }}>
                          <span>
                            <PhoneOutlined /> {guest.phone}
                          </span>
                          <span>
                            <TeamOutlined /> {guest.guests} guests
                          </span>
                        </div>
                      </div>

                      {/* RIGHT BUTTONS */}
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        {guest.status !== "STD" && (
                          <Button
                            icon={<CheckOutlined />}
                            style={{
                              background: "#2F3856",
                              color: "#fff",
                              borderRadius: 10,
                              padding: "0 18px",
                              height: 40,
                            }}
                            onClick={() => {
                              setSelectedWaitlistGuest(guest);
                              setSeatGuestDrawerOpen(true);
                            }}
                          >
                            Seat Guest
                          </Button>
                        )}

                        <Button
                          icon={<CloseOutlined />}
                          style={{
                            borderRadius: 10,
                            padding: "0 18px",
                            height: 40,
                          }}
                          onClick={() => saveToWaitlist({ ...guest, waitlistId: guest.id, status: "CL" })}
                        >
                          Close
                        </Button>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      )}
      <Drawer
        visible={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        width="80%"
        maskStyle={{
          backgroundColor: "rgba(0, 0, 0, 0.3)", // light transparent mask
        }}
        bodyStyle={{ padding: "25px 40px", background: "#FFFFFF" }}
        headerStyle={{ display: "none" }}
      >
        <div
          style={{
            position: "absolute",
            right: 20,
            top: 20,
            cursor: "pointer",
            fontSize: 20,
            color: "#444",
          }}
          onClick={() => setDrawerOpen(false)}
        >
          <CloseOutlined />
        </div>

        {/* Title */}
        <h1 style={{ fontSize: "25px", fontWeight: 600, marginBottom: 20 }}>Reservations</h1>

        {/* Filters */}
        <div style={{ display: "flex", gap: 20, marginBottom: 30 }}>
          <DatePicker
            size="large"
            style={{ width: "250px", height: 35, borderRadius: 10, padding: "8px 10px" }}
            format="DD-MM-YYYY"
            value={filterDate}
            onChange={(v) => setFilterDate(v)}
          />

          <Input
            prefix={<SearchOutlined />}
            placeholder="Search by name or phone..."
            size="large"
            style={{ borderRadius: 10, height: 35, flex: 1 }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div
          style={{
            maxHeight: "65vh",
            overflowY: "auto",
            paddingRight: "10px",
          }}
        >
          {/* Reservation List */}
          {filteredReservations.length === 0 ? (
            <p style={{ textAlign: "center", color: "#888", marginTop: 30 }}>No reservations found</p>
          ) : (
            filteredReservations.map((res, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #E5E7EB",
                  padding: "20px",
                  borderRadius: 12,
                  marginBottom: 20,
                  display: res.status === "CL" ? "none" : "",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span style={{ fontSize: "15px", fontWeight: 500 }}>{res.name}</span>

                      <span
                        style={{
                          background: res.status === "confirmed" ? "#C7F9CC" : "#FFE8A3",
                          color: "#333",
                          padding: "2px 10px",
                          fontSize: "13px",
                          borderRadius: 8,
                        }}
                      >
                        {res.status}
                      </span>
                    </div>

                    <div style={{ marginTop: 8, display: "flex", gap: 25 }}>
                      <span>
                        <PhoneOutlined /> {res.phone}
                      </span>
                      <span>
                        <ClockCircleOutlined /> {res.time}
                      </span>
                      <span>
                        <TeamOutlined /> {res.guests} guests
                      </span>
                    </div>
                  </div>

                  <div style={{ display: res.status === "OCU" ? "none" : "flex", alignItems: "center", gap: 10 }}>
                    <Button
                      icon={<CheckOutlined />}
                      style={{
                        background: "#2F3856",
                        color: "#fff",
                        borderRadius: 10,
                        padding: "0 18px",
                        height: 40,
                      }}
                      onClick={() => handleReservationCheckIn(res)}
                    >
                      Check In
                    </Button>

                    <Button
                      icon={<CloseOutlined />}
                      style={{
                        borderRadius: 10,
                        padding: "0 18px",
                        height: 40,
                      }}
                    >
                      No Show
                    </Button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </Drawer>
      {/* ---------------- MERGE / SPLIT TABLES DRAWER ---------------- */}
      {/* <Drawer
        visible={mergeDrawerOpen}
        onClose={closeMergeDrawer}
        width="70%"
        maskStyle={{ backgroundColor: "rgba(0,0,0,0.3)" }}
        bodyStyle={{
          padding: "0px",
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
        headerStyle={{ display: "none" }}
      >
        <div
          style={{
            position: "absolute",
            right: 20,
            top: 20,
            cursor: "pointer",
            fontSize: 20,
            color: "#444",
            zIndex: 10,
          }}
          onClick={closeMergeDrawer}
        >
          <CloseOutlined />
        </div>
        <div style={{ padding: "25px 40px 10px" }}>
          <h1 style={{ fontSize: "20px", fontWeight: 600, marginBottom: 5 }}>Merge / Split Tables</h1>
          <p style={{ fontSize: 13, color: "#6B7280", marginBottom: 10 }}>Manage table combinations and divisions</p>
          <h3 style={{ marginBottom: 12, fontSize: 15, fontWeight: 600 }}>Select Action</h3>
          <div
            style={{
              border: "1px solid #D1D5DB",
              borderRadius: 10,
              padding: "14px",
              marginBottom: 10,
              display: "flex",
              alignItems: "center",
              gap: 15,
              cursor: "pointer",
              background: "#F9FAFB",
            }}
          >
            <Checkbox />
            <div
              style={{
                width: 42,
                height: 42,
                borderRadius: "50%",
                background: "#E0F2FE",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 20,
              }}
            >
              <AppstoreAddOutlined />
            </div>

            <div>
              <div style={{ fontSize: 15, fontWeight: 600 }}>Merge Tables</div>
              <div style={{ fontSize: 12, color: "#6B7280" }}>Combine multiple table bills into one unified table</div>
            </div>
          </div>
          <div
            style={{
              border: "1px solid #E5E7EB",
              borderRadius: 10,
              padding: "14px",
              marginBottom: 20,
              display: "flex",
              alignItems: "center",
              gap: 15,
              cursor: "pointer",
            }}
          >
            <Checkbox />

            <div
              style={{
                width: 42,
                height: 42,
                borderRadius: "50%",
                background: "#FFEFE1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 20,
              }}
            >
              <ExpandAltOutlined />
            </div>

            <div>
              <div style={{ fontSize: 15, fontWeight: 600 }}>Split Table</div>
              <div style={{ fontSize: 12, color: "#6B7280" }}>Divide current table into separate sub-tables</div>
            </div>
          </div>
          <h3 style={{ marginBottom: 6, fontSize: 15, fontWeight: 600 }}>Select Tables to Merge</h3>
          <p style={{ marginBottom: 10, fontSize: 12, color: "#6B7280" }}>Choose 2 or more tables with active orders</p>
        </div>
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "0px 40px 120px",
          }}
        >
          {tableList
            .filter((tbl) => tbl.statusType !== "OCU")
            .map((tbl, i) => (
              <div
                key={i}
                onClick={() => setSelectedTableForSeating(tbl)}
                style={{
                  border: "1px solid #E5E7EB",
                  borderRadius: 10,
                  padding: "14px",
                  marginBottom: 5,
                  display: "flex",
                  alignItems: "center",
                  gap: 15,
                  cursor: "pointer",
                  background: selectedTableForSeating?.cwrFbTableId === tbl.cwrFbTableId ? "#DBEAFE" : "#F9FAFB",
                  borderColor: selectedTableForSeating?.cwrFbTableId === tbl.cwrFbTableId ? "#2563EB" : "#E5E7EB",
                  transition: "0.2s",
                }}
              >
                <Checkbox checked={selectedTableForSeating?.cwrFbTableId === tbl.cwrFbTableId} style={{ pointerEvents: "none" }} />

                <div style={{ flex: 1 }}>
                  <strong style={{ fontSize: 16 }}>{tbl.name}</strong>

                  <div style={{ marginTop: 5, color: "#444", fontSize: 13 }}>
                    <TeamOutlined style={{ marginRight: 6 }} /> {tbl.noOfPersons || 0} guests • {tbl.sectionName}
                  </div>
                </div>

                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: tbl.statusType === "RES" ? "#D97706" : "#10B981",
                  }}
                >
                  {tbl.statusType === "RES" ? "Reserved" : "Available"}
                </div>
              </div>
            ))}

          {tableList.filter((tbl) => tbl.statusType !== "OCU").length === 0 && (
            <p
              style={{
                textAlign: "center",
                color: "#888",
                marginTop: 40,
              }}
            >
              No available tables
            </p>
          )}
        </div>

        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#fff",
            padding: "12px 30px",
            borderTop: "1px solid #E5E7EB",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button style={{ height: 40, borderRadius: 8 }} onClick={closeMergeDrawer}>
            Cancel
          </Button>

          <Button
            type="primary"
            style={{
              height: 40,
              background: "#374151",
              borderRadius: 8,
              width: "180px",
              fontWeight: 600,
            }}
          >
            Merge 0 Tables
          </Button>
        </div>
      </Drawer> */}
      <Drawer
        visible={mergeDrawerOpen}
        onClose={() => {
          closeMergeDrawer();
          setSelectedTablesForMerge([]);
          setMergeOrSplitAction("merge");
        }}
        width="70%"
        maskStyle={{ backgroundColor: "rgba(0,0,0,0.3)" }}
        bodyStyle={{
          padding: "0px",
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
        headerStyle={{ display: "none" }}
      >
        {/* Close Icon */}
        <div
          style={{
            position: "absolute",
            right: 20,
            top: 20,
            cursor: "pointer",
            fontSize: 20,
            color: "#444",
            zIndex: 10,
          }}
          onClick={() => {
            closeMergeDrawer();
            setSelectedTablesForMerge([]);
            setMergeOrSplitAction("merge");
          }}
        >
          <CloseOutlined />
        </div>
        {/* -------- FIXED TOP SECTION -------- */}
        <div style={{ padding: "25px 40px 10px" }}>
          <h1 style={{ fontSize: "20px", fontWeight: 600, marginBottom: 5 }}>Merge / Split Tables</h1>
          <p style={{ fontSize: 13, color: "#6B7280", marginBottom: 10 }}>Manage table combinations and divisions</p>
          {/* Select Action */}
          <h3 style={{ marginBottom: 12, fontSize: 15, fontWeight: 600 }}>Select Action</h3>
          {/* Merge Option */}
          <div
            style={{
              border: mergeOrSplitAction === "merge" ? "2px solid #2563EB" : "1px solid #D1D5DB",
              borderRadius: 10,
              padding: "14px",
              marginBottom: 10,
              display: "flex",
              alignItems: "center",
              gap: 15,
              cursor: "pointer",
              background: mergeOrSplitAction === "merge" ? "#DBEAFE" : "#F9FAFB",
            }}
            onClick={() => handleActionChange("merge")}
          >
            <Checkbox checked={mergeOrSplitAction === "merge"} style={{ pointerEvents: "none" }} />
            <div
              style={{
                width: 42,
                height: 42,
                borderRadius: "50%",
                background: "#E0F2FE",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 20,
              }}
            >
              <AppstoreAddOutlined />
            </div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 600 }}>Merge Tables</div>
              <div style={{ fontSize: 12, color: "#6B7280" }}>Combine multiple table bills into one unified table</div>
            </div>
          </div>
          {/* Split Option */}
          <div
            style={{
              border: mergeOrSplitAction === "split" ? "2px solid #2563EB" : "1px solid #E5E7EB",
              borderRadius: 10,
              padding: "14px",
              marginBottom: 20,
              display: "flex",
              alignItems: "center",
              gap: 15,
              cursor: "pointer",
              background: mergeOrSplitAction === "split" ? "#DBEAFE" : "#fff",
            }}
            onClick={() => handleActionChange("split")}
          >
            <Checkbox checked={mergeOrSplitAction === "split"} style={{ pointerEvents: "none" }} />
            <div
              style={{
                width: 42,
                height: 42,
                borderRadius: "50%",
                background: "#FFEFE1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 20,
              }}
            >
              <ExpandAltOutlined />
            </div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 600 }}>Split Table</div>
              <div style={{ fontSize: 12, color: "#6B7280" }}>Divide current table into separate sub-tables</div>
            </div>
          </div>
          <h3 style={{ marginBottom: 6, fontSize: 15, fontWeight: 600 }}>{mergeOrSplitAction === "merge" ? "Select Tables to Merge" : "Select Table to Split"}</h3>
          <p style={{ marginBottom: 10, fontSize: 12, color: "#6B7280" }}>
            {mergeOrSplitAction === "merge" ? "Choose 2 or more available tables" : "Choose one available table to split"}
          </p>
        </div>
        {/* -------- SCROLLABLE TABLE LIST -------- */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "0px 40px 120px",
          }}
        >
          {tableList.filter(isNormalAvailableTable).map((tbl, i) => {
            const isSelected = selectedTablesForMerge.includes(tbl.cwrFbTableId);
            return (
              <div
                key={i}
                onClick={() => handleTableSelection(tbl.cwrFbTableId)}
                style={{
                  border: "1px solid #E5E7EB",
                  borderRadius: 10,
                  padding: "14px",
                  marginBottom: 5,
                  display: "flex",
                  alignItems: "center",
                  gap: 15,
                  cursor: "pointer",
                  background: isSelected ? "#DBEAFE" : "#F9FAFB",
                  borderColor: isSelected ? "#2563EB" : "#E5E7EB",
                  transition: "0.2s",
                }}
              >
                <Checkbox checked={isSelected} style={{ pointerEvents: "none" }} />
                <div style={{ flex: 1 }}>
                  <strong style={{ fontSize: 16 }}>{tbl.name}</strong>
                  <div style={{ marginTop: 5, color: "#444", fontSize: 13 }}>
                    <TeamOutlined style={{ marginRight: 6 }} /> Capacity: {tbl.capacity || 0} • {tbl.sectionName}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#10B981",
                  }}
                >
                  Available
                </div>
              </div>
            );
          })}
          {tableList.filter((tbl) => tbl.statusType === "OPN").length === 0 && (
            <p
              style={{
                textAlign: "center",
                color: "#888",
                marginTop: 40,
              }}
            >
              No available tables
            </p>
          )}
        </div>
        {/* -------- FIXED FOOTER -------- */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#fff",
            padding: "12px 30px",
            borderTop: "1px solid #E5E7EB",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            style={{ height: 40, borderRadius: 8 }}
            onClick={() => {
              closeMergeDrawer();
              setSelectedTablesForMerge([]);
              setMergeOrSplitAction("merge");
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            disabled={mergeOrSplitAction === "merge" ? selectedTablesForMerge.length < 2 : selectedTablesForMerge.length !== 1}
            style={{
              height: 40,
              background:
                (mergeOrSplitAction === "merge" && selectedTablesForMerge.length >= 2) || (mergeOrSplitAction === "split" && selectedTablesForMerge.length === 1)
                  ? "#374151"
                  : "#9CA3AF",
              borderRadius: 8,
              width: "180px",
              fontWeight: 600,
            }}
            onClick={mergeOrSplitAction === "merge" ? handleMergeTables : handleSplitTableClick}
          >
            {mergeOrSplitAction === "merge" ? `Merge ${selectedTablesForMerge.length} Tables` : "Split Table"}
          </Button>
        </div>
      </Drawer>

      {/* ---------------- WAITLIST & QUEUE DRAWER ---------------- */}
      <Drawer
        visible={waitlistDrawerOpen}
        onClose={() => setWaitlistDrawerOpen(false)}
        width="80%"
        maskStyle={{ backgroundColor: "rgba(0,0,0,0.3)" }}
        bodyStyle={{
          padding: "0px 30px",
          background: "#fff",
          height: "100%",
          overflow: "auto",
        }}
        headerStyle={{ display: "none" }}
      >
        {/* Close Icon */}
        <div
          style={{
            position: "absolute",
            right: 20,
            top: 20,
            cursor: "pointer",
            fontSize: 18,
            color: "#444",
            zIndex: 10,
          }}
          onClick={() => setWaitlistDrawerOpen(false)}
        >
          <CloseOutlined />
        </div>

        {/* Title */}
        <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 10, marginTop: 15 }}>Waitlist & Queue Management</h1>

        {/* --------- TOGGLE BUTTONS --------- */}
        <div
          style={{
            display: "flex",
            background: "#F4F4F5",
            borderRadius: 10,
            marginBottom: 20,
            padding: 4,
          }}
        >
          {/* CURRENT WAITLIST */}
          {/* <div
    onClick={() => setWaitlistTab("current")}
    style={{
      flex: 1,
      padding: "10px 0",
      textAlign: "center",
      background: waitlistTab === "current" ? "#fff" : "transparent",
      fontWeight: waitlistTab === "current" ? 600 : 500,
      fontSize: 14,
      borderRadius: 8,
      cursor: "pointer",
      boxShadow:
        waitlistTab === "current"
          ? "0 2px 4px rgba(0,0,0,0.05)"
          : "none",
    }}
  >
    Current Waitlist ({waitlistList.length})
  </div> */}

          {/* ADD TO WAITLIST */}
          <div
            onClick={() => setWaitlistTab("add")}
            style={{
              flex: 1,
              padding: "10px 0",
              textAlign: "center",
              background: waitlistTab === "add" ? "#fff" : "transparent",
              fontWeight: waitlistTab === "add" ? 600 : 500,
              fontSize: 14,
              borderRadius: 8,
              cursor: "pointer",
              color: waitlistTab === "add" ? "#000" : "#6B7280",
              boxShadow: waitlistTab === "add" ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
            }}
          >
            Add to Waitlist
          </div>
        </div>
        {/* ---------------- SHOW ADD FORM ---------------- */}
        {waitlistTab === "add" && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "calc(100vh - 130px)", // fits drawer
            }}
          >
            {/* SCROLLABLE FORM */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                paddingRight: 10,
                paddingBottom: 20,
                //marginTop: 10,
              }}
            >
              {/* Contact Number */}
              {/* <div style={{ marginBottom: 15 }}>
                <label style={{ fontSize: 14, fontWeight: 600 }}>Contact Number *</label>
                <Input
                  placeholder="Enter 10-digit mobile"
                  size="large"
                  style={{ borderRadius: 8, marginTop: 6 }}
                  maxLength={10}
                  value={waitlistForm.phone}
                  onChange={handleWaitlistContactSearch}
                  onKeyPress={(e) => {
                    if (["e", "E", "+", "-", ".", ","].includes(e.key)) e.preventDefault();
                  }}
                />
              </div> */}

              <div style={{ marginBottom: 15 }}>
                <label style={{ fontSize: 14, fontWeight: 600 }}>Contact Number *</label>

                <Input
                  placeholder="Enter 10-digit mobile"
                  size="large"
                  style={{
                    borderRadius: 8,
                    marginTop: 6,
                    borderColor: phoneError ? "#ff4d4f" : undefined,
                  }}
                  // maxLength={10}
                  value={waitlistForm.phone}
                  onChange={handleWaitlistContactSearch}
                  onKeyPress={(e) => {
                    if (["e", "E", "+", "-", ".", ","].includes(e.key)) e.preventDefault();
                  }}
                />

                {phoneError && (
                  <div
                    style={{
                      color: "#ff4d4f",
                      fontSize: 12,
                      marginTop: 4,
                    }}
                  >
                    {phoneError}
                  </div>
                )}
              </div>

              {/* Guests */}
              <div style={{ marginBottom: 15 }}>
                <label style={{ fontSize: 14, fontWeight: 600 }}>How Many Guests *</label>
                <div style={{ marginTop: 12, display: "flex", flexWrap: "wrap", gap: 10 }}>
                  {numbers?.map((num, i) => {
                    const isSelected = waitlistForm?.guests === num;
                    return (
                      <div
                        key={i}
                        onClick={() => setWaitlistForm((prev) => ({ ...prev, guests: num }))}
                        style={{
                          padding: "10px 18px",
                          borderRadius: 10,
                          cursor: "pointer",
                          border: isSelected ? "2px solid #2F3856" : "1px solid #ccc",
                          background: isSelected ? "#2F3856" : "#fff",
                          color: isSelected ? "#fff" : "#000",
                          fontWeight: 600,
                          minWidth: 55,
                          textAlign: "center",
                        }}
                      >
                        {num}
                      </div>
                    );
                  })}
                </div>
                {waitlistErrors.guests && <p style={{ color: "red", marginTop: 6 }}>{waitlistErrors.guests}</p>}
              </div>

              {/* Name */}
              <div style={{ marginBottom: 15 }}>
                <label style={{ fontSize: 14, fontWeight: 600 }}>Guest Name *</label>
                <Input
                  placeholder="Enter guest name"
                  size="large"
                  style={{ borderRadius: 8, marginTop: 6 }}
                  ref={waitlistNameRef}
                  value={waitlistForm.name}
                  onChange={(e) => setWaitlistForm({ ...waitlistForm, name: e.target.value })}
                  status={waitlistErrors.name ? "error" : ""}
                />
                {waitlistErrors.name && <p style={{ color: "red", marginTop: 4 }}>{waitlistErrors.name}</p>}
              </div>

              {/* ETA */}
              <div>
                <label style={{ fontSize: 14, fontWeight: 600 }}>Estimated Wait Time (minutes)</label>
                <Input
                  placeholder="15"
                  size="large"
                  style={{ borderRadius: 8, marginTop: 6 }}
                  value={waitlistForm.eta}
                  onChange={(e) => setWaitlistForm({ ...waitlistForm, eta: e.target.value })}
                  status={waitlistErrors.eta ? "error" : ""}
                />
                {waitlistErrors.eta && <p style={{ color: "red", marginTop: 4 }}>{waitlistErrors.eta}</p>}
              </div>
            </div>

            {/* FIXED BUTTON AT BOTTOM */}
            <div
              style={{
                //padding: "5px 0",
                background: "#fff",
                borderTop: "1px solid #E5E7EB",
              }}
            >
              <Button
                type="primary"
                size="large"
                icon={<TeamOutlined />}
                style={{
                  width: "100%",
                  height: 45,
                  background: "#2F3856",
                  borderRadius: 10,
                  fontWeight: 500,
                  marginBottom: "10px",
                }}
                onClick={saveToWaitlist}
              >
                Add to Waitlist
              </Button>
            </div>
          </div>
        )}
      </Drawer>

      {/* ---------------- SEAT GUEST DRAWER ---------------- */}
      <Drawer
        visible={seatGuestDrawerOpen}
        onClose={() => {
          (setSeatGuestDrawerOpen(false), setTransferBill(false));
        }}
        width="80%"
        maskStyle={{ backgroundColor: "rgba(0,0,0,0.3)" }}
        bodyStyle={{
          padding: "0px", // remove padding from root
          background: "#fff",
          height: "100%",
        }}
        headerStyle={{ display: "none" }}
      >
        {/* WRAPPER TO HOLD CONTENT + FOOTER */}
        <div style={{ position: "relative", height: "100%", padding: "20px 30px 0" }}>
          {/* Close Icon */}
          <div
            style={{
              position: "absolute",
              right: 30,
              top: 20,
              cursor: "pointer",
              fontSize: 20,
              color: "#444",
              zIndex: 10,
            }}
            onClick={() => {
              (setSeatGuestDrawerOpen(false), setTransferBill(false));
            }}
          >
            <CloseOutlined />
          </div>

          {/* Title */}
          <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 5 }}>{transferBill ? "Transfer Bill to Another Table" : "Select Table to Seat Guest"}</h1>

          <p style={{ color: "#555", marginBottom: 25, fontSize: 14 }}>
            {transferBill ? (
              <>Select an available table to transfer the bill</>
            ) : (
              <>
                Guest Count: <b>{selectedWaitlistGuest?.guests ?? 0}</b> • Showing only available tables
              </>
            )}
          </p>

          {/* SCROLLABLE CONTENT */}
          <div
            style={{
              overflowY: "auto",
              height: "calc(100% - 100px)", // leave space for footer
              paddingRight: 10,
              paddingBottom: 50,
            }}
          >
            <div
              style={
                !transferBill
                  ? {
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
                      gap: "20px",
                    }
                  : {}
              }
            >
              {transferBill ? (
                <Scrollbars autoHide style={{ height: "73vh" }}>
                  <InfiniteScroll
                    dataLength={tableCards.length}
                    hasMore={true}
                    endMessage={
                      <p className="center">
                        <b>Yay! you have seen it all</b>
                      </p>
                    }
                    style={{ overflowX: "hidden" }}
                  >
                    <Row gutter={[16, 16]}>
                      {[...tableData]
                        .sort((a, b) => {
                          const extractParts = (name) => {
                            const match = name.trim().match(/^([a-zA-Z\s]+?)(\d+)?$/);
                            return match ? [match[1].trim().toUpperCase(), parseInt(match[2] || 0, 10)] : [name.toUpperCase(), 0];
                          };

                          const [aText, aNum] = extractParts(a.name);
                          const [bText, bNum] = extractParts(b.name);

                          if (aText < bText) return -1;
                          if (aText > bText) return 1;

                          return aNum - bNum;
                        })
                        .map((table) => (
                          <Col key={table.id} xs={24} sm={12} md={12} lg={8} xl={8}>
                            <Card
                              className={`table-card ${table.statusType}`}
                              key={table.cwrFbTableId}
                              onClick={() => setSelectedTableForSeating(table)}
                              style={{
                                borderRadius: "16px",
                                padding: "22px",
                                height: "170px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                cursor: "pointer",
                                border: selectedTableForSeating?.cwrFbTableId === table.cwrFbTableId ? "1px solid black" : "2px solid #E0E0E0",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "1.2em",
                                  fontWeight: 600,
                                  marginBottom: "6px",
                                }}
                              >
                                {table.name}
                              </div>

                              <div
                                style={{
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  marginBottom: "8px",
                                }}
                              >
                                {table.statusType === "ONG" || table.statusType === "OCU"
                                  ? "ORDER PLACED"
                                  : table.statusType === "STD"
                                    ? "SEATED"
                                    : table.statusType === "RES"
                                      ? "RESERVED"
                                      : "AVAILABLE"}
                              </div>
                              {table.statusType === "STD" ||
                                table.statusType === "ONG" ||
                                (table.statusType === "OCU" && (
                                  <div
                                    style={{
                                      fontSize: "1.05em",
                                      marginBottom: "8px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    👥 {table.noOfPersons ?? 0} / {table.noOfPersons ?? 0}
                                  </div>
                                ))}
                              {table.statusType === "OCU" && <div style={{ fontSize: "1.1em", fontWeight: 600 }}>{table.guestName || ""}</div>}

                              {table.statusType === "RES" && table.reservedTime && <div style={{ fontSize: "0.95em", marginTop: "6px" }}>{table.reservedTime}</div>}

                              {table.statusType === "OCU" && table.time && <div style={{ fontSize: "0.95em", marginTop: "6px" }}>{table.time}</div>}
                            </Card>
                          </Col>
                        ))}
                    </Row>
                  </InfiniteScroll>
                </Scrollbars>
              ) : (
                <>
                  {tableList
                    .filter((tbl) => tbl.statusType === "OPN")
                    .map((tbl) => (
                      <div
                        key={tbl.cwrFbTableId}
                        onClick={() => setSelectedTableForSeating(tbl)}
                        style={{
                          borderRadius: 16,
                          padding: "22px",
                          height: 150,
                          cursor: "pointer",
                          textAlign: "center",
                          background: selectedTableForSeating?.cwrFbTableId === tbl.cwrFbTableId ? "#DBEAFE" : "#F5F5F5",
                          border: selectedTableForSeating?.cwrFbTableId === tbl.cwrFbTableId ? "3px solid #2563EB" : "2px solid #E0E0E0",
                          transition: "0.2s",
                        }}
                      >
                        <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>{tbl.name}</div>
                        <div style={{ fontSize: 14, color: "#666" }}>AVAILABLE</div>
                      </div>
                    ))}
                </>
              )}
            </div>

            {tableList.filter((tbl) => tbl.statusType === "OPN").length === 0 && <p style={{ textAlign: "center", color: "#888", marginTop: 40 }}>No available tables</p>}
          </div>

          {/* FIXED FOOTER BUTTONS INSIDE DRAWER */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              background: "#fff",
              padding: "15px 30px",
              borderTop: "1px solid #E5E7EB",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              style={{ height: 42, borderRadius: 10, width: "48%" }}
              onClick={() => {
                setSelectedTableForSeating(null);
                setSeatGuestDrawerOpen(false);
                setTransferBill(false);
              }}
            >
              Cancel
            </Button>

            <Button
              type="primary"
              disabled={!selectedTableForSeating}
              style={{
                height: 42,
                borderRadius: 10,
                width: "48%",
                fontWeight: 600,
                background: selectedTableForSeating ? "#2F3856" : "#9CA3AF",
              }}
              onClick={() => {
                if (transferBill) {
                  handleTransferBill(selectedTable, selectedTableForSeating);

                  setSeatGuestDrawerOpen(false);
                  setTransferBill(false);
                  setSelectedTableForSeating(null);
                } else {
                  console.log("entered into seat guest ======>");
                  handleSeatGuestToTable(selectedTableForSeating, selectedWaitlistGuest, "STD");
                  setSelectedTableForSeating(null);
                }
              }}
            >
              Confirm Selection
            </Button>
          </div>
        </div>
      </Drawer>

      {/* ---------------- RESERVATION CHECK-IN TABLE DRAWER ---------------- */}
      <Drawer
        visible={checkInDrawerOpen}
        onClose={() => {
          setSelectedCheckInTable(null);
          setCheckInDrawerOpen(false);
        }}
        width="80%"
        maskStyle={{ backgroundColor: "rgba(0,0,0,0.3)" }}
        bodyStyle={{
          padding: "20px 30px",
          background: "#fff",
          height: "100%",
        }}
        headerStyle={{ display: "none" }}
      >
        {/* Close Icon */}
        <div
          style={{
            position: "absolute",
            right: 30,
            top: 20,
            cursor: "pointer",
            fontSize: 20,
            color: "#444",
          }}
          onClick={() => setCheckInDrawerOpen(false)}
        >
          <CloseOutlined />
        </div>

        {/* TITLE */}
        <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 5 }}>Select Table for Check-In</h1>

        {selectedReservation && (
          <p style={{ color: "#555", marginBottom: 20, fontSize: 14 }}>
            Guest: <b>{selectedReservation.name}</b> • {selectedReservation.guests} guests
          </p>
        )}

        {/* TABLE GRID */}
        <div
          style={{
            overflowY: "auto",
            height: "calc(100% - 120px)",
            paddingRight: 10,
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
              gap: "20px",
            }}
          >
            {tableList
              .filter((tbl) => tbl.statusType === "OPN") // Only available tables
              .map((tbl) => (
                <div
                  key={tbl.cwrFbTableId}
                  onClick={() => setSelectedCheckInTable(tbl)}
                  style={{
                    borderRadius: 16,
                    padding: "22px",
                    height: 150,
                    cursor: "pointer",
                    textAlign: "center",
                    background: selectedCheckInTable?.cwrFbTableId === tbl.cwrFbTableId ? "#DBEAFE" : "#F5F5F5",
                    border: selectedCheckInTable?.cwrFbTableId === tbl.cwrFbTableId ? "3px solid #2563EB" : "2px solid #E0E0E0",
                    transition: "0.2s",
                  }}
                >
                  <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>{tbl.name}</div>
                  <div style={{ fontSize: 14, color: "#666" }}>AVAILABLE</div>
                </div>
              ))}

            {tableList.filter((tbl) => tbl.statusType === "OPN").length === 0 && (
              <p
                style={{
                  textAlign: "center",
                  color: "#888",
                  marginTop: 40,
                  gridColumn: "1/-1",
                }}
              >
                No available tables
              </p>
            )}
          </div>
        </div>

        {/* FOOTER BUTTONS */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#fff",
            padding: "15px 30px",
            borderTop: "1px solid #E5E7EB",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            style={{ height: 42, borderRadius: 10, width: "48%" }}
            onClick={() => {
              setSelectedCheckInTable(null);
              setCheckInDrawerOpen(false);
            }}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            disabled={!selectedCheckInTable}
            style={{
              height: 42,
              borderRadius: 10,
              width: "48%",
              fontWeight: 600,
              background: selectedCheckInTable ? "#2F3856" : "#9CA3AF",
            }}
            onClick={() => {
              // ⭐ CALL ORIGINAL LOGIC WITH SELECTED TABLE
              handleReservationCheckIn(selectedReservation, selectedCheckInTable, "STD");

              setSelectedCheckInTable(null);
              setCheckInDrawerOpen(false);
            }}
          >
            Confirm Allocation
          </Button>
        </div>
      </Drawer>

      {displayReserveTablesPopup && (
        <TableManagement {...props} setDisplayReserveTablesPopup={setDisplayReserveTablesPopup} displayReserveTablesPopup={displayReserveTablesPopup} guestForm={guestForm} />
      )}
    </>
  );
};

export default TableFeatures;
